var _defs, _rect, _path, _path2, _rect2, _circle, _circle2, _ellipse, _path3, _path4, _path5, _path6, _path7, _ellipse2, _ellipse3, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path8, _path9, _path10, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCiAnversoIlustracion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    role: "img",
    "aria-label": "Persona sosteniendo el anverso de su cedula junto al rostro",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgA",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef4fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbe7f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "skinA",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d5b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7b48d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hairA",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a5433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e3520"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shirtA",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a7cf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0168fa"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "url(#bgA)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 160c0-28 20-46 50-46s50 18 50 46z",
    fill: "url(#shirtA)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62c0-27 15-44 36-44s36 17 36 44v52c0 9-6 15-14 15h-8l-2-48c0-15-6-24-16-24s-16 9-16 24l-2 48h-8c-8 0-14-6-14-15z",
    fill: "url(#hairA)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 82,
    width: 18,
    height: 24,
    rx: 7,
    fill: "#e7b48d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 60,
    r: 6.5,
    fill: "#e7b48d"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 60,
    r: 6.5,
    fill: "#e7b48d"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68,
    cy: 58,
    rx: 27,
    ry: 31,
    fill: "url(#skinA)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 56c-1-22 11-34 27-34s28 12 27 34c-3-11-8-17-15-19-7 7-24 8-34 3-3 4-4 9-5 16z",
    fill: "url(#hairA)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 56c-2 18-1 34 3 48",
    stroke: "#4e3520",
    strokeWidth: 5,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56c2 18 1 34-3 48",
    stroke: "#4e3520",
    strokeWidth: 5,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50 50c4-3 10-3 13 0",
    stroke: "#4e3520",
    strokeWidth: 2.6,
    fill: "none",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50c3-3 9-3 13 0",
    stroke: "#4e3520",
    strokeWidth: 2.6,
    fill: "none",
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.5,
    cy: 58,
    rx: 5,
    ry: 4.2,
    fill: "#ffffff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.5,
    cy: 58,
    rx: 5,
    ry: 4.2,
    fill: "#ffffff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 58,
    r: 2.6,
    fill: "#4a3626"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 58,
    r: 2.6,
    fill: "#4a3626"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 58,
    r: 1.2,
    fill: "#1c273c"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 58,
    r: 1.2,
    fill: "#1c273c"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.4,
    cy: 57,
    r: 0.8,
    fill: "#ffffff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.4,
    cy: 57,
    r: 0.8,
    fill: "#ffffff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60v7",
    stroke: "#d99f77",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61 74c3 3 11 3 14 0",
    stroke: "#c96a4a",
    strokeWidth: 2.6,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148 160c-2-26 2-50 6-64",
    stroke: "url(#skinA)",
    strokeWidth: 19,
    fill: "none",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-8 123 85)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 66,
    width: 58,
    height: 38,
    rx: 4,
    fill: "#ffffff",
    stroke: "#b4bdce",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 66,
    width: 58,
    height: 9,
    rx: 4,
    fill: "#0168fa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 71,
    width: 58,
    height: 4,
    fill: "#0168fa"
  }), /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 73,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 3.2,
    fontWeight: "bold",
    fill: "#ffffff"
  }, "CEDULA DE IDENTIDAD"), /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 79,
    width: 14,
    height: 18,
    rx: 1.5,
    fill: "#e3e7ed",
    stroke: "#97a3b9",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 85,
    r: 3.2,
    fill: "#677793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 96c0-3.5 2.6-6 6-6s6 2.5 6 6z",
    fill: "#677793"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 80,
    width: 30,
    height: 2.6,
    rx: 1.3,
    fill: "#cdd4e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 86,
    width: 22,
    height: 2.6,
    rx: 1.3,
    fill: "#cdd4e0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 92,
    width: 27,
    height: 2.6,
    rx: 1.3,
    fill: "#cdd4e0"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1c273c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 99,
    width: 1.2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 99,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 99,
    width: 1.2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.5,
    y: 99,
    width: 1.8,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 99,
    width: 1.2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.5,
    y: 99,
    width: 2.2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 99,
    width: 1.2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 99,
    width: 1.8,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.5,
    y: 99,
    width: 1.2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 99,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.5,
    y: 99,
    width: 1.2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 99,
    width: 1.6,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 99,
    width: 1.2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.5,
    y: 99,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 99,
    width: 1.2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.5,
    y: 99,
    width: 1.8,
    height: 4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#skinA)",
    stroke: "#d99f77",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 97,
    width: 9,
    height: 16,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 98,
    width: 9,
    height: 17,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 99,
    width: 9,
    height: 16,
    rx: 4.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiAnversoIlustracion);
export default __webpack_public_path__ + "static/media/ciAnversoIlustracion.dd24d9a946e5c1ea3423f071d38e27ad.svg";
export { ForwardRef as ReactComponent };